class CartDrawer extends HTMLElement {
  constructor() {
  super();

  this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
  this.setHeaderCartIconAccessibility();

  const storageKey = 'miautique-cart-return-url';
  const cartPath = window.routes.cart_url.replace(/\/+$/, '');
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  const isCartPage = currentPath === cartPath;

  /* /cart niemals dem Kunden zeigen:
     zurück zur letzten Shopseite und dort Drawer öffnen */
  if (isCartPage && !window.Shopify?.designMode) {
    let targetUrl = null;

    try {
      const savedUrl = sessionStorage.getItem(storageKey);

      if (savedUrl) {
        targetUrl = new URL(savedUrl, window.location.origin);
      }
    } catch (error) {
      targetUrl = null;
    }

    const targetPath = targetUrl
      ? targetUrl.pathname.replace(/\/+$/, '') || '/'
      : '';

    const targetIsInvalid =
      !targetUrl ||
      targetUrl.origin !== window.location.origin ||
      targetPath === cartPath ||
      targetPath.includes('/checkouts');

    if (targetIsInvalid) {
      const fallbackPath =
        window.routes.cart_url.replace(/cart\/?$/, '') || '/';

      targetUrl = new URL(fallbackPath, window.location.origin);
    }

    targetUrl.searchParams.set('open_cart', '1');

    window.location.replace(
      targetUrl.pathname +
        targetUrl.search +
        targetUrl.hash
    );

    return;
  }

  /* open_cart entfernen, Drawer öffnen und saubere URL behalten */
  const cleanUrl = new URL(window.location.href);
  const shouldOpenCart =
    cleanUrl.searchParams.get('open_cart') === '1';

  cleanUrl.searchParams.delete('open_cart');

  const cleanRelativeUrl =
    cleanUrl.pathname +
    cleanUrl.search +
    cleanUrl.hash;

  /* Diese Seite als Rückkehrziel merken:
     Produktseite, Kollektion, Startseite usw. */
  try {
    sessionStorage.setItem(storageKey, cleanRelativeUrl);
  } catch (error) {
    /* Falls Session Storage blockiert ist, läuft der Shop trotzdem weiter */
  }

  if (shouldOpenCart) {
    window.history.replaceState({}, '', cleanRelativeUrl);

    setTimeout(() => {
      this.open();
    }, 0);
  }
}

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
